<template>
    <div>
        <el-checkbox v-model="item_check_box">{{ 123 }}</el-checkbox>
    </div>
</template>

<script>
export default {
    name: 'CheckBox',
    props: {
        roleId: {
            type: Number
        }
    },
    data() {
        return {
            data_role_id: '',
            item_check_box: false,
        }
    },
    watch: {
        // roleId (n, o) {
        //     // this.label_value = ''
        //     if (n !== o) {
        //         console.log('nnn',n)
        //         // this.label_value = n
        //     }
        // },
        // role_id: {
        //     handler(n, o) {
        //         console.log('comn',n)
        //         console.log('como',o)
        //         if (n !== o) {
        //             console.log('组件',n)
        //             this.data_role_id = n
        //         }
        //     },
        // }
    },
    mounted () {
        console.log('组件',this.roleId)
    }

}
</script>


// WEBPACK FOOTER //
// src/pages/count/common/CheckBox.vue